import { Download, FileText } from 'lucide-react'

import { Button } from '../ui/button'

const reports = [
  {
    title: 'Medicamentos Controlados',
    subtitle: 'Reporte oficial COFEPRIS',
    description:
      'Formato oficial para reporte trimestral de medicamentos controlados según normativa vigente.',
    iconClassName: 'text-red-400',
    iconContainerClassName: 'bg-red-500/15',
    buttonText: 'Generar Reporte Excel',
  },
  {
    title: 'Antibióticos',
    subtitle: 'Reporte para autoridades',
    description:
      'Reporte de dispensación de antibióticos con datos completos de prescripción y médico tratante.',
    iconClassName: 'text-orange-400',
    iconContainerClassName: 'bg-orange-500/15',
    buttonText: 'Generar Reporte Excel',
  },
  {
    title: 'Historial de Auditoría',
    subtitle: 'Registro de acciones',
    description:
      'Log completo de todas las operaciones realizadas en el módulo regulatorio para trazabilidad.',
    iconClassName: 'text-blue-400',
    iconContainerClassName: 'bg-blue-500/15',
    buttonText: 'Generar Reporte PDF',
  },
  {
    title: 'Reporte Consolidado',
    subtitle: 'Todos los productos regulados',
    description:
      'Reporte consolidado que incluye todos los medicamentos controlados y antibióticos en un solo archivo.',
    iconClassName: 'text-green-400',
    iconContainerClassName: 'bg-green-500/15',
    buttonText: 'Generar Reporte Excel',
  },
]

export function RegulatoryExportReports() {
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      {reports.map((report) => (
        <div
          key={report.title}
          className="rounded-lg border border-border bg-card p-6"
        >
          <div className="mb-4 flex items-center gap-3">
            <div className={`rounded-lg p-3 ${report.iconContainerClassName}`}>
              <FileText className={`h-6 w-6 ${report.iconClassName}`} />
            </div>

            <div>
              <h3 className="font-semibold text-card-foreground">
                {report.title}
              </h3>

              <p className="text-sm text-card-description">
                {report.subtitle}
              </p>
            </div>
          </div>

          <p className="mb-4 text-sm text-card-description">
            {report.description}
          </p>

          <Button className="w-full" variant="outline">
            <Download className="mr-2 h-4 w-4" />
            {report.buttonText}
          </Button>
        </div>
      ))}
    </div>
  )
}